// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__3z1TG","noInteraction":"EventWrapper_noInteraction__B7uRq","pointerPassthrough":"EventWrapper_pointerPassthrough__3UqmB"};